import { cn as e } from "../cn.js";
import { getColorScheme as t, getInitials as n, getStyles as r, getTint as i } from "./style.js";
import * as a from "react";
import { Fragment as o, jsx as s, jsxs as c } from "react/jsx-runtime";
import { Avatar as l } from "@ark-ui/react/avatar";
// src/design/avatar/index.tsx
var u = a.forwardRef(({ src: t, alt: a, fallback: o, status: u, onStatusChange: d, config: f, className: p, tint: m }, h) => {
	let g = r(f), _ = n(o);
	return /* @__PURE__ */ c("div", {
		className: g.container(),
		children: [/* @__PURE__ */ c(l.Root, {
			ref: h,
			className: e(g.root(), p),
			onStatusChange: d,
			children: [t && /* @__PURE__ */ s(l.Image, {
				src: t,
				alt: a,
				className: g.image()
			}), /* @__PURE__ */ s(l.Fallback, {
				className: g.fallback(m ?? i(o)),
				children: _
			})]
		}), u && /* @__PURE__ */ s("div", {
			className: g.status({ status: u }),
			"aria-label": `Status: ${u}`
		})]
	});
});
u.displayName = "Avatar";
var d = a.forwardRef(({ children: t, className: n, config: i, onStatusChange: a, src: u, alt: d, fallback: m, ...h }, g) => {
	let _ = r(i);
	return /* @__PURE__ */ s(l.Root, {
		ref: g,
		className: e(_.root(), n),
		onStatusChange: a,
		...h,
		children: t ?? /* @__PURE__ */ c(o, { children: [/* @__PURE__ */ s(p, { children: m }), u ? /* @__PURE__ */ s(f, {
			src: u,
			alt: d ?? ""
		}) : null] })
	});
});
d.displayName = "Avatar.Root";
var f = a.forwardRef(({ className: t, ...n }, i) => {
	let a = r();
	return /* @__PURE__ */ s(l.Image, {
		ref: i,
		className: e(a.image(), t),
		...n
	});
});
f.displayName = "Avatar.Image";
var p = a.forwardRef(({ children: t, className: n, ...i }, a) => {
	let o = r();
	return /* @__PURE__ */ s(l.Fallback, {
		ref: a,
		className: e(o.fallback(), n),
		...i,
		children: t
	});
});
p.displayName = "Avatar.Fallback";
var m = a.forwardRef(({ status: t, config: n, className: i, ...a }, o) => {
	let c = r(n);
	return /* @__PURE__ */ s("div", {
		ref: o,
		className: e(c.status({ status: t }), i),
		"aria-label": `Status: ${t}`,
		...a
	});
});
m.displayName = "Avatar.StatusIndicator";
var h = a.forwardRef(({ children: t, className: n, ...i }, a) => {
	let o = r();
	return /* @__PURE__ */ s("div", {
		ref: a,
		className: e(o.container(), n),
		...i,
		children: t
	});
});
h.displayName = "Avatar.Container";
var g = a.forwardRef(({ src: t, alt: i, fallback: a, name: o, status: u, onStatusChange: d, config: f, className: p }, m) => {
	let h = r(f), g = n(o || a);
	return /* @__PURE__ */ c("div", {
		className: h.container(),
		children: [/* @__PURE__ */ c(l.Root, {
			ref: m,
			className: e(h.root(), p),
			onStatusChange: d,
			children: [t && /* @__PURE__ */ s(l.Image, {
				src: t,
				alt: i,
				className: h.image()
			}), /* @__PURE__ */ s(l.Fallback, {
				className: h.plainFallback(),
				children: g
			})]
		}), u && /* @__PURE__ */ s("div", {
			className: h.status({ status: u }),
			"aria-label": `Status: ${u}`
		})]
	});
});
g.displayName = "PlainAvatar";
var _ = Object.assign(u, {
	Root: d,
	Image: f,
	Fallback: p,
	StatusIndicator: m,
	Container: h,
	Plain: g,
	getStyles: r
});
export { _ as Avatar, t as getColorScheme, n as getInitials, i as getTint };

//# sourceMappingURL=index.js.map